import React from 'react';
import { BedDouble, ZapOff, BookOpen, Coffee } from 'lucide-react';
export function SymptomsSection() {
  const symptoms = [{
    icon: <BedDouble className="w-6 h-6 text-background" data-id="element-284" />,
    text: <span data-id="element-285">
          Te despertás <strong className="text-navy" data-id="element-286">más cansado</strong> de lo
          que te acostaste.
        </span>
  }, {
    icon: <ZapOff className="w-6 h-6 text-background" data-id="element-287" />,
    text: <span data-id="element-288">
          A las 3 de la tarde tu{' '}
          <strong className="text-navy" data-id="element-289">cerebro "se apaga"</strong> y necesitás
          azúcar o café para seguir.
        </span>
  }, {
    icon: <BookOpen className="w-6 h-6 text-background" data-id="element-290" />,
    text: <span data-id="element-291">
          Leés la misma frase tres veces y{' '}
          <strong className="text-navy" data-id="element-292">no lográs concentrarte</strong>.
        </span>
  }, {
    icon: <Coffee className="w-6 h-6 text-background" data-id="element-293" />,
    text: <span data-id="element-294">
          A media tarde{' '}
          <strong className="text-navy" data-id="element-295">necesitás algo dulce o un café</strong>{' '}
          para poder seguir.
        </span>
  }];
  return <section className="py-4 md:py-14 px-6 bg-background" data-id="element-296">
      <div className="max-w-5xl mx-auto" data-id="element-297">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-navy mb-8 md:mb-16" data-id="element-298">
          ¿Te resulta familiar?
        </h2>

        <div className="grid md:grid-cols-2 gap-4 md:gap-8 mb-8 md:mb-16" data-id="element-299">
          {symptoms.map((symptom, index) => <div key={index} className="flex items-start gap-4 p-6 bg-white rounded-xl shadow-sm border border-navy/5 hover:border-accent/30 transition-colors" data-id="element-300">
              <div className="flex-shrink-0 w-12 h-12 bg-accent rounded-lg flex items-center justify-center shadow-md" data-id="element-301">
                {symptom.icon}
              </div>
              <p className="text-lg text-navy/80 font-medium pt-2" data-id="element-302">
                {symptom.text}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-303">
          <p className="inline-block px-8 py-4 bg-navy text-amber font-serif text-xl md:text-2xl italic rounded-full shadow-lg" data-id="element-304">
            "No te falta <strong data-id="element-305">voluntad</strong>. Te falta una{' '}
            <strong data-id="element-306">señal clara al cerebro</strong>."
          </p>
        </div>
      </div>
    </section>;
}